export const CONST_SET_CMS_LEVEL_USER = 'CONST_SET_CMS_LEVEL_USER';
export const PUSH_CARROUSELS = 'PUSH_CARROUSELS';
export const EXTEND_CARROUSELS = 'EXTEND_CARROUSELS';
export const SET_FAVORITES = 'SET_FAVORITES';
export const CONST_SET_CONTENT_LIST = 'CONST_SET_CONTENT_LIST';
export const SET_CAROUSEL_DATA = 'SET_CAROUSEL_DATA';
export const CONST_SET_CMS_LEVEL = 'CONST_SET_CMS_LEVEL';
export const FLUSH_OVERLOAD = 'FLUSH_OVERLOAD';
export const SET_BACKGROUND = 'SET_BACKGROUND';
export const DELETE_FAVORITE = 'DELETE_FAVORITE';
export const CONST_SET_SEEN = 'CONST_SET_SEEN';
export const REMOVE_SEEN_CAROUSEL = 'REMOVE_SEEN_CAROUSEL';
